const prefix = 'SummaryCompany';

export enum SummaryCompanyField {
  ID = `${prefix}.id`,
  NAME = `${prefix}.name`,
}
